import React from "react"
import {
    CTable,
    CTableRow,
    CTableHeaderCell,
    CTableBody,
    CTableDataCell,
    CSpinner,
    CTableHead,
    CRow,
    CCol,
    CFormLabel,
    CImage} from '@coreui/react'
import {
    cilCloudDownload, cilSearch} from '@coreui/icons'
import AppButton from 'src/components/AppButton'
import ServerConnector from 'src/ServerConnector'
import PageHeader from "src/components/PageHeader"
import DatePicker from "react-date-picker"
import { getDBDate } from "src/util/DateUtil"
import AscIcon from '../../assets/images/asc_icon.png'
import DescIcon from '../../assets/images/desc_icon.png'
import SortNoneIcon from '../../assets/images/sort_none.png'


export default class TopMentorsReport extends React.Component {
    constructor(props) {
        super(props);

        var today = new Date();

        this.state = {
            spinner: false,
            reportData: [],
            fromDate: new Date(today.getFullYear()-1, today.getMonth(), today.getDate()),
            toDate: today,
            sortBy: "",
            sortOrder: ""
        };
    }
    componentDidMount() {
        this.loaddata('REPORT')
    }

    loaddata(format) {

        this.setState({
            spinner: true
        });

        let connector = new ServerConnector();
        let dataMap = {
            "_action_code": "GET_TOP_MENTORS_REPORT",
            "format": format,
            "from_date": getDBDate(this.state.fromDate),
            "to_date": getDBDate(this.state.toDate),
        }

        if (this.state.sortBy.length > 0 && this.state.sortOrder.length > 0) {

            dataMap["sort_by"] = this.state.sortBy;
            dataMap["sort_order"] = this.state.sortOrder;
        }

        connector.postData(dataMap, (data) => { // success

            if (format == "REPORT") {

                this.setState({
                    spinner: false,
                    reportData: data.data
                });
            }
            else {
                this.setState({
                    spinner: false,
                });

                window.open(data.data[0].file_path, '_blank', 'noreferrer');
            }
        }, (err_cd, msg, data) => { // failure

            if (format == "REPORT") {
                this.setState({
                    spinner: false,
                    reportData: []
                });
            }
            else {
                this.setState({
                    spinner: false,
                });
            }
        })
    }

    handleExportXls() {

        this.loaddata('XLS');
    }

    updateInput(key, value) {

        this.setState({
            [key]: value
        });
    }

    onSort(sortBy) {

        var sortOrder = 'ASC';
        if (sortBy == this.state.sortBy) {
            sortOrder = this.state.sortOrder == "ASC" ? "DESC" : "ASC";
        }

        this.setState({
            sortBy: sortBy, 
            sortOrder: sortOrder
        }, () => {
            this.loaddata('REPORT');
        });
    }

    render() {
        return (
            <>
                <PageHeader page_name={this.props.page_name} >
                    <AppButton
                        color="primary"
                        name="Export To XLS"
                        icon={cilCloudDownload}
                        isLoading={false}
                        onClick={() => this.handleExportXls()} />
                </PageHeader>
                <CRow>
                    <CCol md="4">
                        <CFormLabel style={{marginRight: 5, fontWeight: 'bold'}}>Start Date:</CFormLabel>
                        <DatePicker 
                            onChange={(value) => this.updateInput("fromDate", value)} 
                            value={this.state.fromDate}
                            format="dd/MM/y"
                            dayPlaceholder="dd"
                            monthPlaceholder="MM"
                            yearPlaceholder="yyyy"
                            showLeadingZeros={true}
                            clearIcon={null}
                            maxDate={new Date()} />
                    </CCol>
                    <CCol md="4">
                        <CFormLabel style={{marginRight: 5, fontWeight: 'bold'}}>End Date:</CFormLabel>
                        <DatePicker 
                            onChange={(value) => this.updateInput("toDate", value)} 
                            value={this.state.toDate}
                            format="dd/MM/y"
                            dayPlaceholder="dd"
                            monthPlaceholder="MM"
                            yearPlaceholder="yyyy"
                            showLeadingZeros={true}
                            clearIcon={null}
                            maxDate={new Date()} />
                    </CCol>
                    <CCol md="4">
                        <AppButton
                            color="primary"
                            name="Search"
                            icon={cilSearch}
                            isLoading={false}
                            onClick={() => { this.loaddata('REPORT'); }} />
                    </CCol>
                </CRow>
                {
                    this.state.spinner ?
                        <div className="spinnerHolder">
                            <CSpinner color="primary" />
                        </div>
                        : null
                }
                <CTable style={{marginTop: 24}} bordered small>
                    <CTableHead style={{verticalAlign: "top"}} color="dark">
                        <CTableRow>
                            <CTableHeaderCell style={{width: '25%'}} scope="col">Mentor Name</CTableHeaderCell>
                            <CTableHeaderCell style={{width: '25%'}} scope="col">
                                <CRow>
                                    <CCol md="10">Total Number of doubts answered</CCol>
                                    <CCol md="2">
                                        <CImage 
                                            src={this.state.sortBy == "ANSWERED" ? this.state.sortOrder == "ASC" ? AscIcon : DescIcon : SortNoneIcon} 
                                            width={16} 
                                            height={16} 
                                            onClick={() => this.onSort('ANSWERED')}
                                            style={{cursor: 'pointer'}} />
                                    </CCol>
                                </CRow>
                            </CTableHeaderCell>
                            <CTableHeaderCell style={{width: '25%'}} scope="col">
                                <CRow>
                                    <CCol md="10">Total Number of doubts answered - accepted</CCol>
                                    <CCol md="2">
                                        <CImage 
                                            src={this.state.sortBy == "ACCEPTED" ? this.state.sortOrder == "ASC" ? AscIcon : DescIcon : SortNoneIcon} 
                                            width={16} 
                                            height={16} 
                                            onClick={() => this.onSort('ACCEPTED')}
                                            style={{cursor: 'pointer'}} />
                                    </CCol>
                                </CRow>
                            </CTableHeaderCell>
                            <CTableHeaderCell style={{width: '25%'}} scope="col">
                                <CRow>
                                    <CCol md="10">Rating</CCol>
                                    <CCol md="2">
                                        <CImage 
                                            src={this.state.sortBy == "RATING" ? this.state.sortOrder == "ASC" ? AscIcon : DescIcon : SortNoneIcon} 
                                            width={16} 
                                            height={16} 
                                            onClick={() => this.onSort('RATING')}
                                            style={{cursor: 'pointer'}} />
                                    </CCol>
                                </CRow>
                            </CTableHeaderCell>
                        </CTableRow>
                    </CTableHead>
                    <CTableBody>
                        {
                            this.state.reportData.map((reportObj, index) => {

                                return(

                                    <CTableRow key={index}>
                                        <CTableDataCell scope="row">
                                            {reportObj.name}
                                        </CTableDataCell>
                                        <CTableDataCell scope="row">
                                            {reportObj.total}
                                        </CTableDataCell>
                                        <CTableDataCell scope="row">
                                            {reportObj.accepted}
                                        </CTableDataCell>
                                        <CTableDataCell scope="row">
                                            {reportObj.rating}
                                        </CTableDataCell>
                                    </CTableRow>
                                );
                            })
                        }
                        {
                            this.state.reportData.length == 0 ?
                                <CTableRow>
                                    <CTableDataCell colSpan={4} className="alignCenter">No Data Available</CTableDataCell>
                                </CTableRow>
                                :
                                null
                        }
                    </CTableBody>
                </CTable>
            </>
        );
    }
}